import { render, staticRenderFns } from "./DrivingSchoolCRUD.vue?vue&type=template&id=4c32e698&lang=pug&"
import script from "./DrivingSchoolCRUD.vue?vue&type=script&lang=js&"
export * from "./DrivingSchoolCRUD.vue?vue&type=script&lang=js&"
import style0 from "./DrivingSchoolCRUD.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
